
  import classNames from 'classnames'
  import type { ShapeComponentType } from '../types'

  export const Blob04:ShapeComponentType = ({ className, ...props }) => {
    return <svg className={classNames('pintxo-shape', className)} {...props} width="128" height="128" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M110.91 32.307C122.191 46.6777 131.445 63.5547 126.751 80.7782C122.164 97.6285 105.016 107.36 88.2945 115.305C70.7729 123.65 51.1978 132.609 33.1162 125.303C14.5278 117.785 5.86037 98.7216 1.75333 80.3783C-2.22037 62.5948 0.33985 44.2248 11.7009 29.4008C23.9687 13.3504 42.0503 -0.593731 63.3056 0.0194917C84.0008 0.632714 98.7488 16.8431 110.91 32.307Z" fill="#0C0D0D"/>
</svg>

  }
  
